<template>
  <section>
    <div
      v-if="!page || page.progress !== 100"
      class="position-absolute m-5 d-none d-lg-block"
      style="width:175px; height: 175px; top: 115px; right: 50px;"
    >
      <img
        class="img-fluid"
        src="/img/dots.svg"
        alt="Image Description"
      >
    </div>
    <div
      v-if="!page || page.progress !== 100"
      class="position-absolute m-5 d-none d-lg-block"
      style="width:175px; height: 175px; bottom: 70px; left: 20px;"
    >
      <img
        class="img-fluid"
        src="/img/dots.svg"
        alt="Image Description"
      >
    </div>

    <div
      v-if="page"
      class="row"
    >
      <div class="col-md-10 offset-md-1 mb-5">
        <div v-if="!loggedIn && page.progress < 100">
          <transition name="fade">
            <div>
              <h1 class="my-4">
                Bitte geben Sie uns <span class="text-primary">eine Minute</span>
              </h1>
              <p class="lead my-3 text-muted">
                Um möglichst genaue Ergebnisse zu liefern, testen wir Ihre Webseite auf Herz und Nieren.
                Dies dauert
                normalerweise etwa eine Minute.
              </p>
            </div>
          </transition>
        </div>

        <div v-else-if="!loggedIn && page.progress === 100">
          <transition name="fade">
            <div>
              <h1 class="my-4  font-weight-600">
                Herzlichen <span class="text-primary">Glückwunsch</span>
              </h1>
              <div
                class="underline-orange"
                style="width: 10%; margin-top: -32px;"
              ></div>
              <p class="lead my-3 text-muted">
                Ihre Ergebnisse stehen bereit. Um den vollständigen Bericht zu sehen, müssen Sie
                sich registrieren. Für Privatpersonen, Kleinunternehmer sowie gemeinnützige Vereine ist
                unser Dienst
                <strong>kostenlos</strong>. Informieren Sie sich hier über unsere Angebote <a
                  href="#preise"
                >für Unternehmen</a>.
              </p>
            </div>
          </transition>
        </div>
      </div>
    </div>

    <span
      v-if="!loggedIn && page"
      class="w-100"
    >

      <transition name="fade">
        <div>
          <base-card>
            <div class="result-overview row">
              <div class="col-md-3 my-2">
                <transition name="fade">
                  <b-link
                    :href="'/register'"
                  >
                    <img
                      v-if="!empty(page.screenshot_path)"
                      :alt="page.title"
                      :src="page.thumbnail_path"
                      class="img-fluid rounded shadow"
                    >

                    <picture v-if="empty(page.screenshot)">
                      <source
                        srcset="/img/no-screenshot.webp"
                        type="image/webp"
                      >
                      <source
                        srcset="/img/no-screenshot.png"
                        type="image/png"
                      >
                      <img
                        :alt="page.title"
                        class="img-fluid rounded shadow"
                        src="/img/no-screenshot.png"
                      >
                    </picture>
                  </b-link>
                </transition>
              </div>
              <div class="col-md-9 my-2">
                <small
                  id="date-popover"
                  class="float-right"
                >
                  Analysiert vor {{ humanDate(page.created_at) }}
                </small>
                <b-popover
                  placement="top"
                  target="date-popover"
                  triggers="hover"
                >
                  {{ longDate(page.created_at) }}
                </b-popover>
                <h5 class="mb-2">
                  <span
                    v-if="!empty(page.title)"
                    class="mb-1"
                  >
                    <transition name="fade">
                      <b-link
                        :class="{ deactivated: page.progress !== 100 }"
                        :disabled="page.progress !== 100"
                        :href="'/register'"
                      >
                        {{ page.title }}
                      </b-link>
                    </transition>
                  </span>
                  <span
                    v-if="page.progress === 100 && empty(page.title)"
                    class="mb-1"
                  >
                    <b-link
                      :disabled="page.progress !== 100"
                      :href="pagePath(page.hash)"
                    >
                      Startseite - {{ page.url }}
                    </b-link>
                  </span>
                  <span
                    v-if="page.progress === -1 && empty(page.title)"
                    class="mb-1"
                  >
                    Unerwarteter Fehler
                  </span>
                  <span
                    v-if="page.progress >= 0 && page.progress < 100 && empty(page.title)"
                    class="mb-5"
                  >
                    {{ page.url }}
                  </span>
                </h5>

                <div style="width: 90%; margin-top: -7px;">
                  <small
                    v-if="!(page.progress >= 0 && page.progress < 100 && empty(page.title))"
                    class="mb-4 mt-0"
                  >
                    {{ page.url }}
                  </small>

                  <transition name="fade">
                    <p
                      v-if="!empty(page.description)"
                      class="mt-3 card-text small"
                    >
                      {{ page.description }}
                    </p>
                  </transition>


                  <success-bar
                    v-if="page.progress === 100"
                    :danger="page.danger_ratio"
                    :show-status="false"
                    :success="page.success_ratio"
                    :warning="page.warning_ratio"
                  ></success-bar>

                  <div
                    v-if="page.progress === -1"
                    class="mt-4 mb-2 text-danger content-vertical-aligned"
                  >
                    <font-awesome-icon :icon="['fal', 'exclamation-circle']"></font-awesome-icon>
                    &nbsp;Leider ist während der Analyse ein Fehler aufgetreten.
                  </div>

                  <analysis-update-bar
                    v-if="page.progress >= 0 && page.progress < 100"
                    :page="page"
                  ></analysis-update-bar>

                </div>
                <a
                  v-if="page.progress === 100"
                  class="btn btn-primary mt-3"
                  href="/register"
                >Auswertung anzeigen</a>

                <a
                  v-if="page.progress === -1"
                  class="btn btn-primary mt-3"
                  @click="rerun"
                >Erneut versuchen</a>

              </div>
            </div>
          </base-card>

          <div
            v-if="page.progress === 100 && results"
            class="row"
          >
            <div class="col-md-12">
              <div
                class="row row-eq-height"
                style="z-index: 9999"
              >
                <special-page-overview
                  :data="results.imprint"
                  :exist="page.imprint && ! empty(page.imprint.url)"
                  :url="'/analyse/' + page.hash + '/impressum'"
                  class="mt-4"
                  guest
                  header="Impressum"
                  icon="file-alt"
                ></special-page-overview>

                <special-page-overview
                  :data="results.privacyPolicy"
                  :exist="page.privacy_policy && ! empty(page.privacy_policy.url)"
                  :url="'/analyse/' + page.hash + '/datenschutz'"
                  class="mt-4"
                  guest
                  header="Datenschutz"
                  icon="user-shield"
                ></special-page-overview>

                <div class="col-md-6 col-lg-3 mt-4">
                  <base-card class="h-100">
                    <h6>AGB</h6>

                    <hr class="mt-2 mb-2">

                    <div class="row">
                      <div class="card-body p-0 text-center text-lg-left mt-3 mt-lg-0">
                        <div
                          class="card-tex text-gray my-2 p-3 text-center my-4"
                        >
                          Ergebnisse stehen nur registrierten Benutzern im Tarif <em>Business</em> oder <em>Premium</em> zur Verfügung.
                        </div>
                      </div>
                    </div>
                  </base-card>

                </div>

                <div class="col-md-6 col-lg-3 mt-4">
                  <base-card class="h-100">
                    <h6>Widerrufsbelehrung</h6>

                    <hr class="mt-2 mb-2">

                    <div class="row">
                      <div class="card-body p-0 text-center text-lg-left mt-3 mt-lg-0">
                        <div
                          class="card-text my-2 text-gray p-3 text-center my-4"
                        >
                          Ergebnisse stehen nur registrierten Benutzern im Tarif <em>Business</em> oder <em>Premium</em> zur Verfügung.
                        </div>
                      </div>
                    </div>
                  </base-card>

                </div>


              </div>

            </div>
          </div>

        </div>

      </transition>

      <a
        v-if="page.progress === 100"
        class="float-right mt-3 mb-4 small"
        href="#"
        @click="page = null"
      >Andere Webseite testen</a>

    </span>

    <div v-if=" loggedIn || !page">
      <div class="row cover content-vertical-aligned">
        <div class="col-lg-8 col-xl-7 my-auto order-md-1">
          <div
            class="start-form"
          >
            <h1 class="my-4 display-4">
              Machen Sie Ihre<br>
              <span class="text-primary">Website rechtssicher</span>
            </h1>
            <div class="underline-orange"></div>
            <p class="lead my-5 text-muted">
              Wir analysieren Ihre Webseite vollautomatisch und geben
              Ihnen Handlungsempfehlungen zur Beseitigung etwaiger rechtlicher Mängel.
            </p>
            <div class="row ml-2 mb-3">
              <div class="col-md-6 content-vertical-aligned mb-3">
                <font-awesome-icon
                  :class="'tc mr-2'"
                  :icon="['fal', 'shield-check']"
                  style="display: table-cell;"
                ></font-awesome-icon>
                <span
                  style="display: table-cell;"
                >Datenschutzerklärung</span>
              </div>
              <div class="col-md-6 content-vertical-aligned mb-3">
                <font-awesome-icon
                  :class="'tc mr-2'"
                  :icon="['fal', 'shield-check']"
                  style="display: table-cell;"
                ></font-awesome-icon>
                <span
                  style="display: table-cell;"
                >Impressum</span>
              </div>
              <div class="col-md-6 content-vertical-aligned mb-3">
                <font-awesome-icon
                  :class="'tc mr-2'"
                  :icon="['fal', 'shield-check']"
                  style="display: table-cell;"
                ></font-awesome-icon>
                <span
                  style="display: table-cell;"
                >Allgemeine Geschäftsbedingungen</span>
              </div>
              <div class="col-md-6 content-vertical-aligned mb-3">
                <font-awesome-icon
                  :class="'tc mr-2'"
                  :icon="['fal', 'shield-check']"
                  style="display: table-cell;"
                ></font-awesome-icon>
                <span
                  style="display: table-cell;"
                >Widerrufsbelehrung</span>
              </div>
            </div>
          </div>

          <form
            v-if="!loggedIn"
            @submit.prevent="submit"
          >
            <slot name="honeypot"></slot>

            <div class="form-group">
              <label
                class="hide"
                for="website"
              >
                URL
              </label>
              <input
                id="website"
                v-model="fields.website"
                autofocus
                class="form-control"
                name="website"
                placeholder="https://www.beispiel.de"
                type="search"
                style="height: 50px;"
              >

              <button
                :disabled="loading"
                class="btn btn-primary float-right ml-2 mt-3"
                style="height: 50px"
              >
                <b-spinner
                  v-show="loading"
                  class="mr-2"
                  label="Small Spinner"
                  small
                  variant="primary"
                ></b-spinner>
                <slot name="buttonText">
                  Analyse starten
                </slot>
              </button>
              <transition name="fade">
                <div
                  v-if="errors && errors.website"
                  class="text-danger small mt-2"
                  v-html="errors.website[0]"
                ></div>
              </transition>
            </div>
          </form>

          <a
            v-if="loggedIn"
            class="btn btn-outline-primary mt-4"
            href="/dashboard"
          >
            Zum Dashboard
            <font-awesome-icon
              :icon="['fal', 'arrow-right']"
              class="ml-3"
              size="sm"
            ></font-awesome-icon>
          </a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {dateHelper} from "../../mixins/dateHelper";

import {BLink, BPopover, BSpinner} from 'bootstrap-vue'

export default {
  components: {BLink, BPopover, BSpinner},

  mixins: [dateHelper],

  props: {
    existingAnalysis: {
      type: Object,
      default() {
        return null
      },
    },
    initResults: {
      type: Object,
      default() {
        return null
      },
    },
    loggedIn: {
      type: Boolean,
      default: false,
    }
  },

  data() {
    return {
      fields: {
        website: ''
      },
      page: this.existingAnalysis,
      results: this.initResults,
      errors: {},
      loading: false,
    }
  },

  mounted() {
    if (!this.page) {
      return;
    }

    if (this.page.progress >= 0 && this.page.progress < 100) {
      window.Echo.channel('search.status.' + this.page.hash).listen('SearchStatusUpdate', e => {
        this.page = e.mainPage;
      });
    }
  },

  methods: {
    submit() {
      let honeyName = document.querySelector('input[name^="favorite_animal"]').getAttribute('name');
      this.fields[honeyName] = document.querySelector('input[name^="favorite_animal"]').getAttribute('value');
      this.fields.date_valid_from = document.querySelector('input[name^="date_valid_from"]').getAttribute('value');

      this.loading = true;
      this.errors = {};

      window.axios.post('/api/analyse', this.fields).then(response => {

        this.page = response.data.mainPage;

        window.Echo.channel('search.status.' + this.page.hash).listen('SearchStatusUpdate', e => {
          this.page = e.mainPage;
          this.results = e.metaResults;
        });

        this.fields.website = '';
        this.loading = false;

        if (process.env.NODE_ENV === 'production') {
          window._paq.push(['trackGoal', 4]);
        }

      }).catch(error => {
        this.loading = false;
        if (error.response.status === 422) {
          this.errors = error.response.data.errors || {};
        } else {
          this.errors.website = ["Unerwarteter Fehler."];
        }
      });
    },

    rerun() {
      this.fields.website = this.page.url;
      this.submit();
    },

    pagePath(hash) {
      if (this.page.progress >= 0 && this.page.progress < 100) {
        return '';
      }

      return '/analyse/' + hash;
    },
  },
}
</script>
